<template>
	<ProductList />
	<ProductDetail />
	<ProductExternalDetail />
	<Cart />
	<Toaster />
</template>

<script setup>
import Toaster from "./components/shared/Toaster.vue";
import Cart from "./components/cart-integration/Cart.vue";
import ProductDetail from "./components/cart-integration/ProductDetail.vue";
import ProductExternalDetail from "./components/cart-integration/ProductExternalDetail.vue";
import ProductList from "./components/cart-integration/ProductList.vue";
import { useProvideToast } from "./composables/useToast";
import { useProvideCartIntegration } from "./composables/useCartIntegration";
import { ECOMMERCE_SITE } from "@/configs/settings";
import { DEFAULT_CTA_BTN } from "@/configs/default"

const props = defineProps({
	videoId: {
		type: String,
		required: true,
	},
	organizationId: {
		type: [String, Number],
		required: true,
	},
	playlistId: {
		type: String,
	},
	products: {
		type: Array,
		default: () => [],
	},
	videoTracking: {
		type: Object,
		default: () => {},
	},
	ecommerceSite: {
		type: Number,
		default: ECOMMERCE_SITE.OTHER
	},
	viewBtnText: {
		type: String,
		default: DEFAULT_CTA_BTN
	}
});

useProvideCartIntegration({ ...props });
useProvideToast();
</script>

<style lang="scss">
@import "./styles/cart-integration";
</style>
